export default class Modal {
    constructor(main) {
        this.main = main;

        this._init();
    }

    _init() {
        this._getEl();
    }

    _getEl() {
        this.$openArr = [...document.querySelectorAll('.js-modal__open')];
        this.$closeArr = [...document.querySelectorAll('.js-modal__close')];

        this.$openArr.forEach(($open) => this._registerOpen($open));
        this.$closeArr.forEach(($close) => this._registerClose($close));
    }

    _registerOpen($open) {
        $open.addEventListener('click', () => this._openModal($open));
    }

    _registerClose($close) {
        $close.addEventListener('click', () => this._closeModal($close));
    }

    _openModal($open) {
        const modalId = $open.dataset.modalId,
            movId = $open.dataset.movId,
            $target = document.getElementById(modalId);

        modalId == 'mov' && this.main.mov.loadMov(movId);
        document.body.classList.add('-lock');
        $target && $target.classList.add('-active');
    }

    _closeModal($close) {
        const $target = $close.closest('.-active');
        document.body.classList.remove('-lock');
        $target && $target.classList.remove('-active');
    }
}
